
import Vue from 'vue';
import { Component, Watch, Prop } from "vue-property-decorator";
import { DateHelper } from '@/util/DateHelper';

@Component({
    components: {
        
    },
  })
export class DateTimePicker extends Vue {
   
    @Prop({default: "Choose date"}) dateLabel: string;
    @Prop({default: null}) date: string;
    @Prop({default: '1970-01-01'}) min: string;
    @Prop({default: '2999-01-01'}) max: string;
    @Prop({default: "Choose time"}) timeLabel: string;
    @Prop({default: ""}) datePickerTitle: string;
    @Prop({default: ""}) timePickerTitle: string;
    @Prop({default: null}) time: string;
    @Prop({default: false}) disabled: boolean;
    @Prop({default: false}) hideIcon: boolean;
    @Prop({default: false}) appendIcon: boolean;
    @Prop({default: false}) allowWeekends: boolean;
    @Prop({default: false}) editingDate: boolean;

    $dateHelper: DateHelper;

    editedDate: string = null;
    updatedDate: string = null;
    dateChooser: boolean = false;
    editedTime: string = null;
    updatedTime: string = null;
    timeChooser: boolean = false;

    @Watch('date', {immediate: true})
    onDateChanged(val: string, oldVal: string) { 
        this.editedDate = val;
        if (!val) {
            // reset
            this.updatedDate = null;
        }
    }

    @Watch('updatedDate')
    onUpdatedDateChanged(val: string, oldVal: string) { 
        if (val) {
            let oldValue = oldVal;
            // on first edit, oldVal is null
            if (!oldValue) {
                // we need to grab the original value from the "date" prop
                oldValue = this.date;
            } 
            this.$emit("date-updated", val, oldValue);
        }
    }

    @Watch('time', {immediate: true})
    onTimeChanged(val: string, oldVal: string) { 
        this.editedTime = val;
        if (!val) {
            // reset
            this.updatedTime = null;
        }
    }

    @Watch('updatedTime')
    onUpdatedTimeChanged(val: string, oldVal: string) { 
        // console.log("watch updatedTime:", "val:", val, "oldVal:", oldVal);
        if (val) {
            this.$emit("time-updated", val);
        }
    }

    get editedDateFormatted(): string {
        if (!this.editedDate) {
            return '';
        }
        return this.$dateHelper.formatDateWithShortWeekDay(this.editedDate + ' ');
    }

    get minDateStamp(): number {
        return new Date(this.min).getTime();
    }

    get maxDateStamp(): number {
        return new Date(this.max).getTime();
    }

    allowedDates(val) {
        const valDate = new Date(val);
        const valDateStamp = valDate.getTime();
        const day = valDate.getDay();
        const isWeekend = (day === 6) || (day === 0);
        return (!isWeekend || this.allowWeekends || this.$store.state.user.showWeekends) 
                && valDateStamp >= this.minDateStamp && valDateStamp <= this.maxDateStamp
    }
   
    created() {
        this.editedDate = this.date;
        this.editedTime = this.time;
    };
}

export default DateTimePicker;
